import styled, { css } from 'react-emotion';
import { themeGet } from 'styled-system';

export const placeholder = (aspectRatio = 177) => css`
  position: relative;
  width: 100%;
  overflow: hidden;
  padding-top: ${aspectRatio}px;
`;

export const Container = styled('div')`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${props => (props.isStillLoading ? '#fff' : '')};
`;

export const LoadingThumb = styled('div')`
  background-color: ${themeGet('colors.greyLightest')};
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

export const FallbackImage = styled('div')`
  background-color: ${themeGet('colors.greyLightest')};
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  color: ${themeGet('colors.blueDarker')};
  font-weight: 300;
  font-size: 14px;
`;

export const Image = styled('div')`
  position: absolute;
  left: 0;
  top: 0;
  background-image: url(${props => props.src});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: 50% 50%;
  transition: opacity 0.5s ease-in;
  opacity: ${props => (props.isVisible ? 1 : 0)};
  width: 100%;
  height: 100%;
`;



// WEBPACK FOOTER //
// ./src/components/image/style.js